module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [(_vm.data.breakdowns && _vm.data.breakdowns[0].on) ? _c('span', _vm._l((_vm.data.breakdowns[0].values), function(b, i) {
    return (b.on) ? _c('span', [_c('span', {
      staticClass: "color swatch",
      style: ({
        'background-color': _vm.colors[_vm.ci[b.name]]
      })
    }), _vm._v("\n            " + _vm._s(b.name) + "\n        ")]) : _vm._e()
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-11c8cdc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SimpleLegend.vue
// module id = 382
// module chunks = 1